import {
  instance as axios,
  setJwtToken,
  setMultiPartHeader,
} from "../../config/axiosInstance";

// ---------------------Dashboard-listing--------------------------
export const dashboardDataApi = async () => {
  const endPoint =
    `admin/dashboard/list`

  return await axios.get(endPoint, setJwtToken());
};
